import { LoginGoogle } from './LoginGoogle/LoginGoogle';

export const Login = LoginGoogle;
